<script>
import form from '@/utils/form';
import materialApi from '@/api/material';
import projectApi from '@/api/project';
import { units } from '@/utils/enum';

import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseField from '@/components/BaseField.vue';
import MaterialCategorySelector from '@/components/exchange/material/MaterialCategorySelector.vue';
import materialCategoryApi from '@/api/materialCategory';
import FileUploaderSingle from '@/components/file/FileUploaderSingle.vue';

export default {
  name: 'MaterialForm',
  components: {FileUploaderSingle, Default, CommonSection, BaseField, MaterialCategorySelector }, // eslint-disable-line
  data() {
    return {
      item: null,
      avatar: null,
      file: null,
      categories: [],
      category: null,
      /* eslint-disable */
      form: {
        name: form.createFieldObject('string', 'Ниименование', ''),
        status: form.createFieldObject('select', 'Статус', null, {}, { progress: 'В работе', paused: 'Пауза', review: 'Проверка', agreement: 'Согласование' }),
        description: form.createFieldObject('textarea', 'Описание', ''),
        volume: form.createFieldObject('float', 'Объем', ''),
        volumeUnit: form.createFieldObject('select', 'Ед изм объема', null, {}, units.volume),
        budget: form.createFieldObject('float', 'Бюджет', ''),
        budgetCurrency: form.createFieldObject('select', 'Валюта бюджета', 'rur', {}, units.currency),
        delivery: form.createFieldObject('select', 'Доставка', null, {}, ['С доставкой', 'Без доставки', 'С доставкой и подъемом']),
        assembly: form.createFieldObject('select', 'Монтаж', null, {}, ['С монтажом', 'Частичный монтаж', 'Без монтажа']),
        deadlineAt: form.createFieldObject('date', 'Срок', null, {}, { no: 'Нет', door: 'До двери', building: 'До здания' }),
        rooms: form.createFieldObject('multi', 'Помещения', [], {}, ['Спальня', 'Кухня', 'Столовая', 'Прихожая', 'Зал']),
      },
      /* eslint-enable */
    };
  },
  computed: {
    id() { return this.$route.params.id; },
  },
  mounted() {
    materialCategoryApi.fetchList({}, true).then(r => { this.categories = r.items; });

    if (this.id === 'new') return;

    materialApi.fetchItem(this.id, true).then(r => {
      this.item = r;
      form.setValues(this.form, r);
      this.category = r.category?.['@id'] ?? null;
      this.avatar = r.avatar;
      this.file = r.file;
    });
  },
  methods: {
    async save() {
      const data = form.getValues(this.form);
      data.category = this.category;
      data.project = projectApi.getIri(this.$route.params.projectId);
      data.avatar = this.avatar?.['@id'] ?? null;
      data.file = this.file?.['@id'] ?? null;

      if (this.item) {
        await materialApi.update(this.item.id, data, true);
      } else {
        await materialApi.create(data, true);
      }

      await this.$router.push({ name: 'material-list', params: this.$route.params });
    },
  },
};
</script>

<template lang="pug">
  Default
    CommonSection(:title="id === 'new' ? 'Добавить материал' : 'Редактировать материал'")
      .exchange-item-form
        .fields
          BaseField(
            v-for="(field, name) in form"
            v-model="field.value"
            v-bind="field"
            :key="name"
            labelOuter
          :class="{ [name]: true }"
          )
          FileUploaderSingle(:file="avatar" @change="avatar = $event" title="Аватар")
          FileUploaderSingle(:file="file" @change="file = $event" title="Файл")
          .category <br> <br>Категория <br><br>
            MaterialCategorySelector(:items="categories" v-model="category"  v-if="categories.length")
        Btn(lg @click="save") Сохранить
</template>

<style scoped lang="scss">
  .fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 40px;
  }

  .category {
    grid-column: 1 / 2 span;
  }

  .description {
    grid-row: 2;
    grid-column: 1 / 2 span;
  }
</style>
